import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserLanguageService } from '../../services/user-language-service/user-language.service';
import { UserDashboardService } from '../../user-dashboard.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {environment} from '../../../../environments/environment.prod';

@Component({
    selector: 'app-user-forgot-password',
    templateUrl: './user-forgot-password.component.html',
    styleUrls: ['./user-forgot-password.component.scss'],
    standalone: false
})
export class UserForgotPasswordComponent implements OnInit {
  @ViewChild('forgotPassForm') forgotPassForm:NgForm
  labels;
  labelsSub: Subscription;
  lang
  langSub: Subscription
  fromEmail: boolean;
  isActive: boolean = true;
  wrongConfirmedPassword: boolean = false
  imageUrl: string
  constructor(
    private snackBar: MatSnackBar,
    private dashboardService: UserDashboardService,
    private languageService: UserLanguageService, public dialog:MatDialog,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.langSub = this.languageService.lang$.subscribe((lang) => {
      this.lang = lang;
    })
    this.imageUrl = environment.loginImagePath3 || "./assets/icons/LogoLESTE.png"
    this.labelsSub = this.languageService.labels$.subscribe((labels) =>{
      this.labels = labels;
    })
    this.fromEmail = !!this.route.snapshot.params['token']
  }

  changeActive(){
    this.isActive = !this.isActive;
  }

  onSubmit(formData) {
    if (this.fromEmail) {
      if(formData.value.password != formData.value.confirmPassword) {
        this.wrongConfirmedPassword = true
        return ;
      }
      this.wrongConfirmedPassword = false
      this.dashboardService.resetPassword({
        id: this.route.snapshot.params['id'],
        token: this.route.snapshot.params['token'],
        password: formData.value.password
      }).subscribe((response) => {
          this.snackBar.open(this.labels.lblPasswordChanged, 'OK', {
            verticalPosition: 'top',
            horizontalPosition: 'end',
            duration: 5000
          })
          this.backToLogin()
      }, error => {
        console.log(error)
        this.snackBar.open(this.labels.lblExpiredLink, 'OK', {
          verticalPosition: 'top',
          horizontalPosition: 'end',
          duration: 5000
        })
      })
    } else {
      this.dashboardService.sendResetPasswordLink({email: formData.value.email, lang: this.lang}).subscribe((response) => {
        this.snackBar.open(this.labels.lblPasswordResetLinkSent, 'OK', {
          verticalPosition: 'top',
          horizontalPosition: 'end',
          duration: 5000
        })
      })
    }
  }

  backToLogin(){
    this.router.navigateByUrl('/login')
  }

  // cancelModal(){
  //   this.dialogRef.close()
  // }

}
